var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "contract"
  }, [_vm._m(0), _c("div", {
    staticClass: "shuangfang"
  }, [_c("div", {
    staticClass: "jf"
  }, [_c("p", {
    staticClass: "p1"
  }, [_vm._v("出租方（甲方）:")]), _c("p", {
    staticClass: "p2 c_aname"
  }, [_vm._v(_vm._s(_vm.res.A))])]), _c("div", {
    staticClass: "jf yf"
  }, [_c("p", {
    staticClass: "p1"
  }, [_vm._v("出租方（乙方）:")]), _c("p", {
    staticClass: "p2 c_bname"
  }, [_vm._v(_vm._s(_vm.res.B))])]), _vm._m(1)]), _vm._m(2), _c("div", {
    staticClass: "fwdz"
  }, [_c("p", {
    staticClass: "fwbt"
  }, [_vm._v("1、房屋地址Location of the property")]), _c("div", {
    staticClass: "fw1"
  }, [_c("u", [_vm._v(" 甲方将其所有的位于")]), _c("textarea", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.addressZh,
      expression: "addressZh"
    }],
    staticClass: "txt c_address",
    attrs: {
      rows: "2",
      cols: "2",
      disabled: "disabled"
    },
    domProps: {
      value: _vm.addressZh
    },
    on: {
      input: function input($event) {
        if ($event.target.composing) return;
        _vm.addressZh = $event.target.value;
      }
    }
  }), _c("b", {
    staticClass: "xian"
  })]), _c("p", {
    staticClass: "p4"
  }, [_vm._v("的房屋及其附属设施在良好状态下出租给乙方使用。")]), _c("div", {
    staticClass: "txt-input"
  }, [_c("u", [_vm._v(" Party A leases to Party B the premises and its ancillary facilities which is locateda")]), _c("textarea", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.addressEn,
      expression: "addressEn"
    }],
    staticClass: "txt c_address",
    attrs: {
      rows: "2",
      cols: "2",
      disabled: "disabled"
    },
    domProps: {
      value: _vm.addressEn
    },
    on: {
      input: function input($event) {
        if ($event.target.composing) return;
        _vm.addressEn = $event.target.value;
      }
    }
  }), _c("b", {
    staticClass: "xian"
  })])]), _c("div", {
    staticClass: "zpqx mto"
  }, [_c("b", {
    staticClass: "b1"
  }, [_vm._v(" 2、租赁期限Lease term")]), _c("p", [_vm._v(" 租聘期限为，自 "), _c("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.res.occupyTime,
      expression: "res.occupyTime"
    }],
    staticClass: "c_start",
    attrs: {
      type: "text",
      disabled: "disabled",
      name: ""
    },
    domProps: {
      value: _vm.res.occupyTime
    },
    on: {
      input: function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.res, "occupyTime", $event.target.value);
      }
    }
  }), _vm._v(" 起至 "), _c("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.res.quitTime,
      expression: "res.quitTime"
    }],
    staticClass: "c_end",
    attrs: {
      type: "text",
      name: "",
      disabled: "disabled"
    },
    domProps: {
      value: _vm.res.quitTime
    },
    on: {
      input: function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.res, "quitTime", $event.target.value);
      }
    }
  }), _vm._v("止。 ")]), _c("p", [_vm._v(" The lease term beginning on "), _c("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.res.occupyTime,
      expression: "res.occupyTime"
    }],
    staticClass: "c_start",
    attrs: {
      type: "text",
      name: "",
      disabled: "disabled"
    },
    domProps: {
      value: _vm.res.occupyTime
    },
    on: {
      input: function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.res, "occupyTime", $event.target.value);
      }
    }
  }), _vm._v(" and ending on "), _c("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.res.quitTime,
      expression: "res.quitTime"
    }],
    staticClass: "c_end",
    attrs: {
      type: "text",
      name: "",
      disabled: "disabled"
    },
    domProps: {
      value: _vm.res.quitTime
    },
    on: {
      input: function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.res, "quitTime", $event.target.value);
      }
    }
  }), _vm._v(" 。 ")])]), _c("div", {
    staticClass: "zpqx mto"
  }, [_c("b", {
    staticClass: "b1"
  }, [_vm._v("3、租金Rent")]), _c("p", [_vm._v(" 金额：双方商定月租金为人民币 "), _c("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.res.rent,
      expression: "res.rent"
    }],
    staticClass: "c_rent_c",
    staticStyle: {
      width: "220px"
    },
    attrs: {
      type: "text",
      disabled: "disabled",
      name: ""
    },
    domProps: {
      value: _vm.res.rent
    },
    on: {
      input: function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.res, "rent", $event.target.value);
      }
    }
  }), _vm._v(" （大写） ")]), _c("p", [_vm._v(" Amount：the rent is RMB "), _c("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.res.rent,
      expression: "res.rent"
    }],
    staticClass: "c_rent",
    staticStyle: {
      width: "220px"
    },
    attrs: {
      type: "text",
      name: "",
      disabled: "disabled"
    },
    domProps: {
      value: _vm.res.rent
    },
    on: {
      input: function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.res, "rent", $event.target.value);
      }
    }
  }), _vm._v(" per month ")])]), _c("div", {
    staticClass: "yjgl mto"
  }, [_c("b", {
    staticClass: "b1",
    staticStyle: {
      "line-height": "35px"
    }
  }, [_vm._v("4、押金管理Deposit Management : ")]), _c("p", {
    staticClass: "p1"
  }, [_vm._v(" 1)、为确保房屋及其附属设施之安全与完好，及租赁期内相关费用之如期结算，乙方同意支付给甲方押金 "), _c("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.res.deposit,
      expression: "res.deposit"
    }],
    staticClass: "c_deposit_c",
    staticStyle: {
      width: "200px"
    },
    attrs: {
      type: "text",
      name: "",
      disabled: "disabled"
    },
    domProps: {
      value: _vm.res.deposit
    },
    on: {
      input: function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.res, "deposit", $event.target.value);
      }
    }
  }), _vm._v(" ，该押金由Wellcee直接收取，Wellcee 收到押金后书面告知甲方，甲方在收到通知后予以确认签收。 ")]), _c("p", {
    staticClass: "p2"
  }, [_vm._v(" 1)、In order to ensure the safety and completeness of the housing and its ancillary facilities and the settlement of the relevant expenses during the lease term, Party B agrees to pay the deposit of RMB "), _c("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.res.deposit,
      expression: "res.deposit"
    }],
    staticClass: "c_deposit",
    staticStyle: {
      width: "200px"
    },
    attrs: {
      type: "text",
      name: "",
      disabled: "disabled"
    },
    domProps: {
      value: _vm.res.deposit
    },
    on: {
      input: function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.res, "deposit", $event.target.value);
      }
    }
  }), _vm._v(" . The whole amount of the deposit is directly charged and eventually managed by Wellcee, and after Wellcee receives the deposit, it will inform Party A in writing. Party A will confirm the booking of the property after receiving the notice from Wellcee. ")]), _c("p", {
    staticClass: "p3"
  }, [_vm._v(" 2)、因乙方违反本合同的规定而产生的违约金、损坏赔偿金和其它相关费用，经甲方告知，丙方可在押金中抵扣，不足部分乙方必须在接到丙方付款通知后十日内补足。 ")]), _c("p", {
    staticClass: "p3"
  }, [_vm._v(" 2)、 In case party B breaches this agreement, party A has right to deduct the related fine from the deposit, as a compensation for damage or any other expenses. In case the deposit is not sufficient to cover such expenses, Party B shall pay the remaining amount within ten days after receiving the written notice of payment from Party A. ")]), _c("p", {
    staticClass: "p3 p4"
  }, [_vm._v(" 3)、如双方执行本协议产生争议，可协商解决，如协商不成，双方一致同意由Wellcee进行调解，如任何一方对Wellcee调解有异议，应在Wellcee调解结果出具后3个工作日内向房屋所在地人民法院提起诉讼主张。甲乙双方可凭法院出具的相关法律文书向丙方出示，Wellcee根据法律文书内容返还押金。 ")]), _c("p", {
    staticClass: "p3"
  }, [_vm._v(" 3)、In case of disputes arising among the parties and related to the implementation of the present agreement such disputes shall be resolved through friendly consultation among the parties; if the parties should not find a friendly settlement of the dispute , then they shall try to find a settlement through the mediation of Wellcee. In case one party should not be satisfied by Wellcee’s mediation, such a party shall promptly inform Wellcee within 3 working days from the issuance of the mediation results, and he/she shall have the right to fill a claim before the local People’s court where the house is located. . Party A and Party B may present the relevant legal documents issued by the court to Wellcee. Wellcee shall return the deposit according to the contents of the aforementioned legal documents. ")]), _c("p", {
    staticClass: "p3 p4"
  }, [_vm._v(" 4)、因甲方原因导致乙方无法在租赁期内正常租用该房屋的，甲方应立即全额退还押金给乙方。 ")]), _c("p", {
    staticClass: "p3"
  }, [_vm._v(" 4)、If Party B will not be able to normally use the apartment because of Party A’s fault poor negligence, then Party A shall immediately refund the deposit to Party B at once. ")]), _c("p", {
    staticClass: "p3 p4"
  }, [_vm._v(" 5)、如因乙方个人原因，临时取消已经预定好的出租房，乙方需要赔偿甲方等待天数的租金。租金从双方确认租房合约之日起开始算起。 ")]), _c("p", {
    staticClass: "p3"
  }, [_vm._v(" 5)、If Party B asks for the cancellation of the already booked property, then Party B shall compensate Party A with an amount equal to the number of days of the property booked from the booking day . The penalty is charged starting from the date on which the two parties confirm the rental contract. The compensation will be deducted from the already paid deposit. ")]), _c("p", {
    staticClass: "p3 p4"
  }, [_vm._v(" 6）、乙方不得擅自转租，若需要转租的，需经甲方同意。 ")]), _c("p", {
    staticClass: "p3"
  }, [_vm._v(" 6)、 Party B shall not arbitrarily sublet the property without part A’s approval ")]), _c("p", {
    staticClass: "p3 p4"
  }, [_vm._v(" 7）、乙方如果在租期结束前退租，甲方有权利要求乙方做出违约赔偿。赔偿金额视甲、乙双方沟通而定。 ")]), _c("p", {
    staticClass: "p3"
  }, [_vm._v(" 7) If Party B wishes to terminate the contract before the end of the lease agreement, Party A shall have the rights to ask for the payment of a penalty fee due to the breach of the agreement. The amount of compensation shall be agreed between Party A and Party B. ")])]), _vm._m(3), _vm._m(4), _vm._m(5), _vm._m(6), _vm._m(7), _c("div", {
    staticClass: "qm-over sdfa c_ainfo"
  }, [_c("p", [_vm._v("Party A甲方：" + _vm._s(_vm.res.A))]), _c("p", [_vm._v("Date日期：    " + _vm._s(_vm.res.create))])]), _c("div", {
    staticClass: "qm-over sdfa c_binfo"
  }, [_c("p", [_vm._v("Party B乙方：" + _vm._s(_vm.res.B))]), _c("p", [_vm._v("Date日期：    " + _vm._s(_vm.res.create))])]), _vm._m(8)]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("p", {
    staticClass: "btsd1"
  }, [_vm._v(" 租房定金管理合同"), _c("br"), _vm._v("LEASE CONTRACT of Rental Deposit ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "jf yf",
    staticStyle: {
      height: "auto",
      "padding-bottom": "30px"
    }
  }, [_c("p", {
    staticClass: "p1",
    staticStyle: {
      width: "100%",
      height: "20px"
    }
  }, [_vm._v(" 平台方（丙方）: "), _c("span", {
    staticStyle: {
      display: "inline-block",
      "margin-left": "50px"
    }
  }, [_vm._v("北京良孝科技有限公司")])]), _c("p", {
    staticClass: "p2",
    staticStyle: {
      width: "100%",
      height: "20px"
    }
  }, [_vm._v(" Platform (Party C):"), _c("span", {
    staticStyle: {
      display: "inline-block",
      "margin-left": "50px"
    }
  }, [_vm._v(" Beijing Liang Xiao Technology Co., Ltd.")])])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "ht-nr"
  }, [_c("b", {
    staticClass: "b1"
  }, [_vm._v("鉴于:")]), _c("p", [_vm._v(" 1、丙方是一家在北京市合法成立并有效存续的有限责任公司，拥有www.wellcee.com 网站及Wellcee & 唯心所寓客户端的经营权，以下简称 Wellcee，可以为交易提供信息技术及保障服务。对平台的使用细则拥有最终解释权。 ")]), _c("b", {
    staticClass: "b1"
  }, [_vm._v("In view of:")]), _c("p", {
    staticStyle: {
      "font-family": "Times New Roman",
      "font-weight": "700"
    }
  }, [_vm._v(" 1. Party C is a limited liability company established and duly existing under Chinese law, it has the right to operate www.wellcee.com as its own website and the Wellcee (唯心所寓）Application and WeChat Admin Platform (hereinafter referred to as “Wellcee”), which can provide information technology and the security of the transaction services offered . Wellcee has the final interpretation of the rules related to the use of the platforms. ")]), _c("p", {
    staticClass: "yv"
  }, [_vm._v(" 2、甲方及乙方均为享有完全民事行为能力和民事权利能力的主体且已在Wellcee注册， 同意遵守Wellcee 各项行为准则，在充分阅读理解本约定情形下，自愿原则签订本《租房定金管理合同》并愿意按照本协议约定执行。 ")]), _c("p", {
    staticStyle: {
      "font-family": "Times New Roman",
      "font-weight": "700"
    }
  }, [_vm._v(" 2. Party A and Party B have full legal capacity of entering the present Agreement, they have registered in Wellcee and they agree to abide by the Wellcee's code of conduct, in the full understanding of this agreement. The aforementioned parties voluntarily signed the present agreement and are willing to comply with the provisions set forth herein. ")]), _c("p", {
    staticClass: "yv"
  }, [_vm._v(" 根据国家有关法律、法规和本市有关规定，甲、乙双方在平等自愿的基础上，经友好协商，就甲方将其合法使用的房屋通过丙方平台出租给乙方使用，乙方承租使用甲方房屋事宜，订立本合同。合同经甲乙双方确认后立即生效。 ")]), _c("p", {
    staticStyle: {
      "font-family": "Times New Roman",
      "font-weight": "700"
    }
  }, [_vm._v(" According to the relevant laws and regulations of the state and the relevant provisions of this municipality, both parties on the basis of equality and voluntariness, through friendly negotiation, agree that Party A leases to Party B its legally owned housing by using Wellcee. Upon signing of the present Agreement, Party B shall have the right to use the rented property for the purpose of living there only. The present agreement shall come into force upon confirmation by both parties. ")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "yjgl mto"
  }, [_c("b", {
    staticClass: "b1"
  }, [_vm._v("5、甲方义务，包括但不限于： "), _c("br"), _vm._v("5、Obligations of Party A include but are not limited to:")]), _c("p", {
    staticClass: "p3 p4"
  }, [_vm._v("1)、甲方须按时将房屋及附属设施交付乙方使用。")]), _c("p", {
    staticClass: "p3"
  }, [_vm._v(" 1)、 Party A will provide the property and attached facilities to Party B for its private use . ")]), _c("p", {
    staticClass: "p3 p4"
  }, [_vm._v(" 2)、房屋设施如因质量原因、自然损耗、不可抗力或意外事件而受到损坏，甲方有修缮并承担相关费用的责任。如甲方未在两周内修复该损坏物，以致乙方无法正常使用房屋设施，乙方有权终止该合约，并要求退还押金。 ")]), _c("p", {
    staticClass: "p3"
  }, [_vm._v(" 2)、In case the property and its attached facilities are damaged because of already existing quality problems, natural damages or other unforeseeable accidents, then Party A shall be responsible to repair it and pay the relevant expenses. If Party A cannot repair the damaged facilities within two weeks so that Party B can’t use the facilities normally, then Party B shall have the right to terminate the contract and Party A shall be obliged to refund the deposit. ")]), _c("p", {
    staticClass: "p3 p4"
  }, [_vm._v(" 3)、甲方应确保出租的房屋享有出租的权利，如租赁期内该房屋发生所有权全部或部分转移、设定他项物权或其他影响乙方权益的事件，甲方应保证所有权人、他项权利人或其他影响乙方权益的第三者能继续遵守本合同所有条款，反之如乙方权益因此遭受损害，甲方应负赔偿责任。 ")]), _c("p", {
    staticClass: "p3"
  }, [_vm._v(" 3)、Party A shall guarantee the lease right of the property. In case of occurrence of ownership transfer in whole or in part, or in case of other accidents affecting the right of lease of party B, party A shall guarantee that the new owner or other related third parties shall be bound by the terms of this agreement . Otherwise, Party A shall be responsible to compensate party B for his/her losses. ")]), _c("p", {
    staticClass: "p3 p4"
  }, [_vm._v(" 4）甲方如果存在网站上传房源信息存和房屋实际情况不符的情况，乙方有权终止该合约，并要求退还押金. ")]), _c("p", {
    staticClass: "p3"
  }, [_vm._v(" 4）In case the actual information of the property should not match with the information uploaded on the website, Party B shall have the right to terminate the contract and to ask for the refund of the deposit. ")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "yjgl mto"
  }, [_c("b", {
    staticClass: "b1"
  }, [_vm._v(" 6、乙方义务，包括但不限于："), _c("br"), _vm._v("6、Obligations of Party B include but are not limited to: ")]), _c("p", {
    staticClass: "p3 p4"
  }, [_vm._v("1)、乙方应按合同的规定按时支付租金。")]), _c("p", {
    staticClass: "p3"
  }, [_vm._v(" 1)、 Party B will pay the rental on a timely manner. ")]), _c("p", {
    staticClass: "p3 p4"
  }, [_vm._v(" 2)、乙方经甲方同意，可在房屋内添置设备、家具。租赁期满后，乙方将添置的设备搬走，并保证不影响房屋的完好及正常使用。 ")]), _c("p", {
    staticClass: "p3"
  }, [_vm._v(" 2)、Party B may add new facilities under Party A’s approval. When this agreement expires, Party B may remove and take away the personal facilities without changing the good conditions of the property for normal use. ")]), _c("p", {
    staticClass: "p3 p4"
  }, [_vm._v(" 3)、乙方应按本合同规定合法使用该房屋，不得擅自改变使用性质。乙方不得在该房屋内存放危险物品。否则，如该房屋及附属设施因此受损，乙方应承担全部责任。 ")]), _c("p", {
    staticClass: "p3"
  }, [_vm._v(" 3)、Party B shall use the property and its attached facilities lawfully according to this agreement, without changing the nature of the property and without storing hazardous materials in it. Otherwise, Party B shall be responsible for any damage caused. ")]), _c("p", {
    staticClass: "p3 p4"
  }, [_vm._v(" 4）、乙方应爱护租用的房屋及其设备，严格按专门的使用要求使用，如因乙方人为使用不当而导致损坏，乙方负责赔偿及修复费用。 ")]), _c("p", {
    staticClass: "p3"
  }, [_vm._v(" 4)、Party B shall take care of the property and its attached facilities , and shall use them according to the specific instructions given by Part A; in case of improper use of the property and/or of its attached facilities, Party B shall pay for the compensation and repairing fees to Party A. ")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "yjgl mto"
  }, [_c("b", {
    staticClass: "b1"
  }, [_vm._v("7. 争议的解决 "), _c("br"), _vm._v("7.Others")]), _c("p", {
    staticClass: "p3 p4"
  }, [_vm._v(" 本合同适用中华人民共和国法律。若有任何争议，甲方和乙方应协商解决，协商解决不成的，应向房屋所在地辖区法院诉讼解决 ")]), _c("p", {
    staticClass: "p3"
  }, [_vm._v(" This agreement has been drafted in accordance with the laws of the People’s Republic of China. Party A and Party B agree that in case of dispute that cannot be resolved between the two parties, the local People’s Court will be used as a last resort. ")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "yjgl mto"
  }, [_c("b", {
    staticClass: "b1"
  }, [_vm._v("8. 合同语言 "), _c("br"), _vm._v("8. Language of the Agreement")]), _c("p", {
    staticClass: "p3 p4"
  }, [_vm._v(" 本协议以中英文书就，如果中英文合同不一致，以中文版合同为准。 ")]), _c("p", {
    staticClass: "p3"
  }, [_vm._v(" This Agreement is made in Chinese and English languages; in case of any discrepancy between the Chinese and the English texts of this agreement, the Chinese text of this agreement shall prevail. ")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "yjgl mto"
  }, [_c("b", {
    staticClass: "b1"
  }, [_vm._v("9. 备注或其他补充条款（以甲方，乙方线下签订的租房合同为准）"), _c("br"), _vm._v("9. Remarks and/or additional terms and conditions")]), _c("p", {
    staticClass: "p3 p4"
  }, [_vm._v(" 本合同主要涉及租房定金的管理事项和纠纷解决建议，不能囊括所有租房过程中可能出现的所有情况和特殊注意事项。 建议甲方、乙方签订线下的租房合同，其内容包括但不限于：房屋设施交割清单、物业管理费、水电费、网络费、特殊注意事项等。 ")]), _c("p", {
    staticClass: "p3"
  }, [_vm._v(" This agreement mainly deals with the management of the rental deposit and the dispute settlement proposal, and can not cover all the situations and special precautions that may arise during the whole renting process. Party A and Party B are recommended to sign an offline contract, and that the content of such offline contract should include but should not be limited to: the settlement of housing facilities, property management fees, utilities, the Internet fee, special precautions ,and any other provision that is deemed to be necessary by the parties. . ")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "qn-over",
    staticStyle: {
      "margin-top": "50px"
    }
  }, [_c("p", {
    staticClass: "p1",
    staticStyle: {
      width: "100%"
    }
  }, [_vm._v("丙方Party C:")]), _c("p", {
    staticClass: "p2"
  }, [_vm._v(" 北京良孝科技有限公司Beijing Liang Xiao Technology Co., Ltd. ")])]);
}];
render._withStripped = true;
export { render, staticRenderFns };